import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { portalBase } from "@/lib/portal";
import { PortalShell, Campo } from "./PortalShell";

export { PortalRecuperar } from "./PortalRecuperar";

const err = (e) => toast.error(formatApiErrorDetail(e?.response?.data?.detail));

export function PortalLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [desafio, setDesafio] = useState(null);
  const [codigo, setCodigo] = useState("");
  const [cargando, setCargando] = useState(false);
  const entrar = (data) => { login(data); nav(portalBase() || "/"); };
  const enviar = async (e) => {
    e.preventDefault(); setCargando(true);
    try {
      if (desafio) { const r = await api.post("/portal/auth/2fa", { desafio, codigo }); entrar(r.data); return; }
      const r = await api.post("/portal/auth/login", f);
      if (r.data.requiere_2fa) { setDesafio(r.data.desafio); setCodigo(""); } else entrar(r.data);
    }
    catch (x) { err(x); if (x?.response?.status === 401 && desafio && /venci/.test(x.response.data?.detail || "")) setDesafio(null); }
    finally { setCargando(false); }
  };
  if (desafio) return <PortalShell titulo="Verificación en dos pasos" sub="Ingresá el código de 6 dígitos de tu app de autenticación.">
    <form onSubmit={enviar} className="space-y-4" data-testid="portal-2fa">
      <Campo label="Código" inputMode="numeric" autoComplete="one-time-code" autoFocus value={codigo} onChange={(e) => setCodigo(e.target.value)} required data-testid="portal-2fa-codigo" />
      <p className="text-xs text-[#cfe9da]/75">¿Perdiste el teléfono? Usá uno de tus códigos de recuperación (formato XXXX-XXXX).</p>
      <button disabled={cargando} className="pa-btn" data-testid="portal-2fa-submit">{cargando ? "Verificando…" : "Verificar"}</button>
      <button type="button" onClick={() => setDesafio(null)} className="pa-link text-xs" data-testid="portal-2fa-volver">Volver</button>
    </form>
  </PortalShell>;
  return <PortalShell titulo="Ingresar" sub="Accedé al panel de inmuebles de tu empresa.">
    <form onSubmit={enviar} className="space-y-4" data-testid="portal-login">
      <Campo label="Correo" type="email" autoComplete="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} required data-testid="portal-login-email" />
      <Campo label="Contraseña" type="password" autoComplete="current-password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required data-testid="portal-login-password" />
      <div className="text-right -mt-1"><Link to={`${portalBase()}/recuperar`} className="pa-link text-xs" data-testid="portal-ir-recuperar">¿Olvidaste tu contraseña?</Link></div>
      <button disabled={cargando} className="pa-btn" data-testid="portal-login-submit">{cargando ? "Ingresando…" : "Ingresar"}</button>
      <p className="text-xs text-[#cfe9da]/75">¿Tu empresa todavía no tiene cuenta? <Link to={`${portalBase()}/registro`} className="pa-link" data-testid="portal-ir-registro">Registrate</Link></p>
    </form>
  </PortalShell>;
}

export function PortalRegistro() {
  const [f, setF] = useState({ name: "", email: "", password: "", empresa: "" });
  const [ok, setOk] = useState(null);
  const enviar = async (e) => {
    e.preventDefault();
    try { const r = await api.post("/portal/auth/register", f); setOk(r.data.mensaje); }
    catch (x) { err(x); }
  };
  return <PortalShell titulo="Crear cuenta" sub="Creá la cuenta de tu empresa. Queda pendiente hasta que la aprobemos.">
    <form onSubmit={enviar} className="space-y-4" data-testid="portal-registro">
      {ok ? <p className="p-3 rounded-xl bg-[#3fae7a]/15 border border-[#3fae7a]/40 text-sm" data-testid="portal-registro-ok">{ok}</p> : <>
        <Campo label="Nombre y apellido" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} required data-testid="portal-reg-nombre" />
        <Campo label="Empresa" value={f.empresa} onChange={(e) => setF({ ...f, empresa: e.target.value })} required data-testid="portal-reg-empresa" />
        <Campo label="Correo" type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} required data-testid="portal-reg-email" />
        <Campo label="Contraseña (mín. 12, con mayúscula, minúscula, número y símbolo)" type="password" minLength={12} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required data-testid="portal-reg-password" />
        <button className="pa-btn" data-testid="portal-reg-submit">Crear cuenta</button></>}
      <p className="text-xs"><Link to={`${portalBase()}/login`} className="pa-link" data-testid="portal-ir-login">Volver a ingresar</Link></p>
    </form>
  </PortalShell>;
}
